/**
 * @mixin NamedValueCacheLocalStorageMixin
 * @todo write description
 */
var NamedValueCacheLocalStorageMixin = function () {
    /**
     * @member {string} _namedValuePrefix
     * @private
     * @memberOf NamedValueCacheLocalStorageMixin
     * @todo write description
     */
    this._namedValuePrefix = 'NamedValueCache/';

    /**
     * @method deleteNamedValue
     * @param {string} keyName
     * @return {Promise|Promise<Error>}
     * @memberOf NamedValueCacheLocalStorageMixin
     * @todo write description
     */
    this.deleteNamedValue = function (keyName) {
        return Promise.resolve().then(() => {
            localStorage.removeItem(this._namedValuePrefix + keyName);
        });
    };

    /**
     * @method getNamedValue
     * @param {string} keyName
     * @param {*} defaultValue
     * @return {Promise<*>|Promise<Error>}
     * @memberOf NamedValueCacheLocalStorageMixin
     * @todo write description
     */
    this.getNamedValue = function (keyName, defaultValue) {
        return Promise.resolve().then(() => {
            let keyValue = localStorage.getItem(this._namedValuePrefix + keyName);

            if (keyValue === null) {
                keyValue = defaultValue;
            }

            return keyValue;
        });
    };

    /**
     * @method setNamedValue
     * @param {string} keyName
     * @param {*} keyValue
     * @return {Promise|Promise<Error>}
     * @memberOf NamedValueCacheLocalStorageMixin
     * @todo write description
     */
    this.setNamedValue = function (keyName, keyValue) {
        return Promise.resolve().then(() => {
            localStorage.setItem(this._namedValuePrefix + keyName, keyValue);
        });
    };

    return this;
};

export { NamedValueCacheLocalStorageMixin };
